import { render, staticRenderFns } from "./admin-dashboard-tabs.vue?vue&type=template&id=70205c64&"
import script from "./admin-dashboard-tabs.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard-tabs.vue?vue&type=script&lang=js&"
import style0 from "./admin-dashboard-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports